export const SET_QUERY = 'SET_QUERY'
export const SET_IDS = 'SET_IDS'

const state = {
  query: '',
  ids: []
}

const mutations = {
  [SET_QUERY] (state, query) {
    state.query = query
  },
  [SET_IDS] (state, ids) {
    state.ids = ids
  }
}

export function createSearch () {
  return {
    namespaced: true,
    state: {...state},
    mutations
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/fuzzy-search.js